import { featureFlagKeys } from 'modules/common/drawers/featureFlagDrawer/const/featureFlagKeys';

import { getFeatureFlagValue } from 'store/session/selectors';

import { initTasksListPage } from './listPage/data/sagas';
import TasksListPage from './listPage/entry';

const isTasksAvailable = (state) =>
  getFeatureFlagValue(state, featureFlagKeys.isTasksAvailable);

export default [
  {
    component: TasksListPage,
    exact: true,
    path: '/tasks',
    helpId: 'tasks_list',
    permissions: [isTasksAvailable],
    saga: initTasksListPage,
  },
];
